@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.accounts.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mobile_wallet.feature.accounts.generated.resources/"

internal val Res.drawable.baseline_check: DrawableResource by lazy {
      DrawableResource("drawable:baseline_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_check.xml", -1, -1),
      ))
    }

internal val Res.drawable.baseline_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:baseline_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_unchecked.xml", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_ic_bank: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_ic_bank", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_ic_bank.xml", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_logo_axis: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_logo_axis", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_logo_axis.png", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_logo_hdfc: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_logo_hdfc", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_logo_hdfc.png", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_logo_icici: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_logo_icici", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_logo_icici.png", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_logo_pnb: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_logo_pnb", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_logo_pnb.png", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_logo_rbl: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_logo_rbl", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_logo_rbl.png", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_logo_sbi: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_logo_sbi", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_logo_sbi.png", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_sim_card_selected: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_sim_card_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_sim_card_selected.xml", -1, -1),
      ))
    }

internal val Res.drawable.feature_accounts_sim_card_unselected: DrawableResource by lazy {
      DrawableResource("drawable:feature_accounts_sim_card_unselected", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_accounts_sim_card_unselected.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("baseline_check", Res.drawable.baseline_check)
  map.put("baseline_unchecked", Res.drawable.baseline_unchecked)
  map.put("feature_accounts_ic_bank", Res.drawable.feature_accounts_ic_bank)
  map.put("feature_accounts_logo_axis", Res.drawable.feature_accounts_logo_axis)
  map.put("feature_accounts_logo_hdfc", Res.drawable.feature_accounts_logo_hdfc)
  map.put("feature_accounts_logo_icici", Res.drawable.feature_accounts_logo_icici)
  map.put("feature_accounts_logo_pnb", Res.drawable.feature_accounts_logo_pnb)
  map.put("feature_accounts_logo_rbl", Res.drawable.feature_accounts_logo_rbl)
  map.put("feature_accounts_logo_sbi", Res.drawable.feature_accounts_logo_sbi)
  map.put("feature_accounts_sim_card_selected", Res.drawable.feature_accounts_sim_card_selected)
  map.put("feature_accounts_sim_card_unselected", Res.drawable.feature_accounts_sim_card_unselected)
}
